import { useState } from "react";

export default function HelloIsland({ initial_count = 0 }) {
  const [count, setCount] = useState(initial_count);

  return (
    <div
      data-testid="hello-island"
      style={{
        padding: "16px",
        border: "1px solid var(--ink-200, #e3e6ec)",
        borderRadius: "8px",
        background: "var(--paper, #ffffff)",
        color: "var(--ink-900, #0b1420)",
        fontFamily: "var(--ui, system-ui)",
        display: "inline-flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <span>HelloIsland count: <strong data-testid="hello-island-count">{count}</strong></span>
      <button
        type="button"
        onClick={() => setCount((c) => c + 1)}
        style={{
          background: "var(--accent, #0b6b7a)",
          color: "#fff",
          border: 0,
          borderRadius: "6px",
          padding: "6px 12px",
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        +1
      </button>
    </div>
  );
}
